import React from 'react';
import { getColumnStyle } from '../../../../utils/formCrafter/columnWidthUtils';
import styles from './ParagraphField.module.css';

/**
 * ParagraphField - Atom component for paragraph display in forms
 *
 * @param {string} content - Paragraph text content (preferred)
 * @param {string} label - Fallback paragraph text to display
 * @param {string} tag - HTML tag to use, defaults to 'p'
 * @param {string} columnWidth - Column width (1, 1/2, 1/3, etc.)
 */
const ParagraphField = ({ content, label, tag = 'p', columnWidth }) => {
  const Tag = tag || 'p';
  const textContent = content || label || '';
  const style = getColumnStyle(columnWidth);

  return (
    <div className={styles.paragraphWrapper} style={style}>
      <Tag className={styles.paragraph}>{textContent}</Tag>
    </div>
  );
};

export default ParagraphField;
